<template lang="">
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" width="53.66" height="53.66" viewBox="0 0 53.66 53.66">
  <g id="Service_Coupons" data-name="Service Coupons" transform="translate(-322.986 -489.701)">
    <circle id="Ellipse_1081" data-name="Ellipse 1081" cx="26.33" cy="26.33" r="26.33" transform="translate(323.486 490.201)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    <g id="Group_8604" data-name="Group 8604" transform="translate(337.102 506.216)">
      <g id="Group_8603" data-name="Group 8603" transform="translate(0 0)">
        <g id="Group_8606" data-name="Group 8606">
          <path id="Path_69820" data-name="Path 69820" d="M.5,11.972A2.736,2.736,0,0,0,.5,6.5" transform="translate(-0.5 1.546)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1"/>
          <path id="Path_69821" data-name="Path 69821" d="M23.236,11.972a2.736,2.736,0,1,1,0-5.472" transform="translate(4.123 1.546)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1"/>
          <path id="Path_69822" data-name="Path 69822" d="M.5,8.545v-6.7A1.273,1.273,0,0,1,1.69.5H26.67a1.273,1.273,0,0,1,1.19,1.341v6.7" transform="translate(-0.5 -0.5)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1"/>
          <path id="Path_69823" data-name="Path 69823" d="M27.859,12.5v5.364a1.273,1.273,0,0,1-1.19,1.341H1.69A1.273,1.273,0,0,1,.5,17.864V12.5" transform="translate(-0.5 1.017)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1"/>
        </g>
      </g>
    </g>
    <line id="Line_919" data-name="Line 919" y2="16.004" transform="translate(354.945 508.724)" fill="none" :stroke="themeColor" stroke-width="1" stroke-dasharray="1.5 1.5"/>
  </g>
</svg>

  </div>
</template>
<script>
export default {
  props: {
    themeColor: {
      type: String,
      default: '#B3B3B3'
    },
    height: {
      type: String,
      default: '53.66px'
    },
    width: {
      type: String,
      default: '53.66px'
    }
  }
}
</script>
<style lang="">

</style>
